export const shortTestimonials = [
  {
    initials: 'MV',
    name: 'Mariana V.',
    place: 'Buenos Aires',
    quote: 'Ordené 12 años de papeles en 3 horas. El neurólogo encontró el informe al instante. Me dijo: “Nunca vi una madre tan preparada”.'
  },
  {
    initials: 'FG',
    name: 'Fernanda G.',
    place: 'Córdoba',
    quote: 'Registré 8 observaciones. El médico vio patrones que no veía. Cambió el tratamiento. Ahora mi hijo está más estable.'
  },
  {
    initials: 'GT',
    name: 'Graciela T.',
    place: 'Rosario',
    quote: 'Preparé mis 5 preguntas ANTES de la consulta. Salí con RESPUESTAS CLARAS, no confundida.'
  }
] as const;

export const extendedTestimonials = [
  {
    name: 'Mariana V.',
    place: 'Buenos Aires',
    quote: '“Ordené 12 años de papeles en 3 horas. El neurólogo encontró el informe al instante. Me dijo: ‘Nunca vi una madre tan preparada’.”'
  },
  {
    name: 'Fernanda G.',
    place: 'Córdoba',
    quote: '“Registré 8 observaciones. El médico vio patrones que no veía. Cambió el tratamiento. Ahora mi hijo está más estable.”'
  },
  {
    name: 'Graciela T.',
    place: 'Rosario',
    quote: '“Preparé mis 5 preguntas ANTES de la consulta. Salí con RESPUESTAS CLARAS, no confundida.”'
  },
  {
    name: 'Karina D.',
    place: 'Mendoza',
    quote: '“Sé qué observar, cómo registrarlo y qué llevar. Llego preparada y eso me calma.”'
  }
] as const;

export const purchases = [
  ['Mariana V.', 'Buenos Aires'],
  ['Fernanda G.', 'Córdoba'],
  ['Graciela T.', 'Rosario'],
  ['Karina D.', 'Mendoza']
] as const;
